import React from 'react'
import { TimePicker } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import moment from 'moment';

const timePicker = () => {
  const format = 'HH:mm';
  
  return (
    <TimePicker  className='time-picker-btn' defaultValue={moment('12:08', format)} format={format} showNow={false} 
    suffixIcon={<RightOutlined className='time-picker-icn' />}   />
  )
}

export default timePicker